import { InfoSet } from "../InfoSets/InfoSet";
import { Device } from "../Core/Device";
import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { Dictionary } from "../Utils/Dictionary";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export interface Win32_DiskDriveEntryJsonWrapper {
//    win32_disk_drive_entry: Win32_DiskDriveEntryJson;
//}

//export interface Win32_DiskDriveEntryJson {
//    device_id: string;
//    caption: string;
//    description: string;
//    fw_rev: string;
//    index: string;
//    interface_type: string;
//    manufacturer: string;
//    model: string;
//    name: string;
//    serial_number: string;
//    size: string;
//}

export class Win32_DiskDriveEntry implements ObjectSerializer {
    //public static FromJson(json: Win32_DiskDriveEntryJson): Win32_DiskDriveEntry {

    //    var result = new Win32_DiskDriveEntry();

    //    if (json.device_id !== undefined) {
    //        result.DeviceID = json.device_id;
    //    }
    //    if (json.caption !== undefined) {
    //        result.Caption = json.caption;
    //    }
    //    if (json.description !== undefined) {
    //        result.Description = json.description;
    //    }
    //    if (json.fw_rev !== undefined) {
    //        result.FirmwareRevision = json.fw_rev;
    //    }
    //    if (json.index !== undefined) {
    //        result.Index = parseInt(json.index);
    //    }
    //    if (json.interface_type !== undefined) {
    //        result.InterfaceType = json.interface_type;
    //    }
    //    if (json.manufacturer !== undefined) {
    //        result.Manufacturer = json.manufacturer;
    //    }
    //    if (json.model !== undefined) {
    //        result.Model = json.model;
    //    }
    //    if (json.name !== undefined) {
    //        result.Name = json.name;
    //    }
    //    if (json.size !== undefined) {
    //        result.Size =parseInt(json.size);
    //    }
    //    if (json.serial_number !== undefined) {
    //        result.SerialNumber = json.serial_number;
    //    }

    //    return result;
    //}

    public DeviceID: string;
    public get HasDeviceID() {
        return !!this.DeviceID;
    }

    public Caption: string;
    public get HasCaption() {
        return !!this.Caption;
    }

    public Description: string;
    public get HasDescription() {
        return !!this.Description;
    }

    public FirmwareRevision: string;
    public get HasFirmwareRevision() {
        return !!this.FirmwareRevision;
    }

    public Index: number;
    public get HasIndex() {
        return this.Index >= 0;
    }

    public InstallDate: number;
	public get HasInstallDate() {
		return (this.InstallDate >= 0);
    }

    public InterfaceType: string;
    public get HasInterfaceType() {
        return !!this.InterfaceType;
    }

    public Manufacturer: string;
    public get HasManufacturer() {
        return !!this.Manufacturer;
    }

    public Model: string;
    public get HasModel() {
        return !!this.Model;
    }

    public Name: string;
    public get HasName() {
        return !!this.Name;
    }

    public Size: number;
    public get HasSize() {
        return this.Size > 0;
    }

    public SerialNumber: string;
    public get HasSerialNumber() {
        return !!this.SerialNumber;
    }

    constructor() {
        this.DeviceID = "";

        this.Caption = "";
        this.Description = "";
        this.FirmwareRevision = "";

        this.Index = -1;
		this.InstallDate = -1;

        this.InterfaceType = "";
        this.Manufacturer = "";
        this.Model = "";

        this.Name = "";
        this.SerialNumber = "";
        this.Size = -1;
	}

	public Write(obj: any, context: any): void {
		obj.win32_disk_drive_entry = {};
		obj = obj.win32_disk_drive_entry;

		obj.device_id = this.DeviceID;

		if (this.HasCaption)
			obj.caption = this.Caption;

		if (this.HasDescription)
			obj.description = this.Description;

		if (this.HasFirmwareRevision)
			obj.fw_rev = this.FirmwareRevision;

		if (this.HasIndex)
			obj.index = ValueEncoder.EncodeInteger(this.Index);

		if (this.HasInstallDate)
			obj.install_date = ValueEncoder.EncodeInteger(this.InstallDate);

		if (this.HasInterfaceType)
			obj.interface_type = this.InterfaceType;

		if (this.HasManufacturer)
			obj.manufacturer = this.Manufacturer;

		if (this.HasModel)
			obj.model = this.Model;

		if (this.HasName)
			obj.name = this.Name;

		if (this.HasSerialNumber)
			obj.serial_number = this.SerialNumber;

		if (this.HasSize)
			obj.size = ValueEncoder.EncodeInteger(this.Size);
	}

	public Read(obj: any, context: any): void {
		if (!obj.win32_disk_drive_entry)
			throw new Error();
		obj = obj.win32_disk_drive_entry;

		if (obj.device_id !== undefined)
			this.DeviceID = obj.device_id;

		if (obj.caption !== undefined)
			this.Caption = obj.caption;

		if (obj.description !== undefined)
			this.Description = obj.description;

		if (obj.fw_rev !== undefined)
			this.FirmwareRevision = obj.fw_rev;

		if (obj.index !== undefined)
			this.Index = ValueEncoder.DecodeInteger(obj.index);

		if (obj.install_date !== undefined)
			this.InstallDate = ValueEncoder.DecodeInteger(obj.install_date);

		if (obj.interface_type !== undefined)
			this.InterfaceType = obj.interface_type;

		if (obj.manufacturer !== undefined)
			this.Manufacturer = obj.manufacturer;

		if (obj.model !== undefined)
			this.Model = obj.model;

		if (obj.name !== undefined)
			this.Name = obj.name;

		if (obj.serial_number !== undefined)
			this.SerialNumber = obj.serial_number;

		if (obj.size !== undefined)
			this.Size = ValueEncoder.DecodeInteger(obj.size);
	}
}


export class Win32_DiskDriveTable extends InfoSet
{
    //public static FromJson(json: InfoSetEntriesJson<Win32_DiskDriveEntryJsonWrapper>, device: Device): Win32_DiskDriveTable {
    //    var result = new Win32_DiskDriveTable(device);

    //    json.entries.forEach((jsonEntry) => {
    //        var entry = Win32_DiskDriveEntry.FromJson(jsonEntry.win32_disk_drive_entry);

    //        result.AddDiskDrive(entry);
    //    });

    //    return result;
    //}

    private _diskTable: Dictionary<string, Win32_DiskDriveEntry>;

	constructor(device: Device) {
		super(device);
        this._diskTable = new Dictionary<string, Win32_DiskDriveEntry>();
		return;
	}

	public Add(deviceID: string): Win32_DiskDriveEntry {
        var diskEntry: Win32_DiskDriveEntry = this.Find(deviceID);

        if (!diskEntry) {
            diskEntry = new Win32_DiskDriveEntry();
            this.AddDiskDrive(diskEntry);
		}

        return diskEntry;
	}

    public AddDiskDrive(diskEntry: Win32_DiskDriveEntry): boolean {
        if (!diskEntry.HasDeviceID)
            return false;

		if (!this._diskTable.ContainsKey(diskEntry.DeviceID)) {
            this._diskTable.Add(diskEntry.DeviceID, diskEntry);
			return true;
		}

		return false;
	}

	public Clear():void {
		this._diskTable.Clear();
	}

	public get Count(): number {
		return this._diskTable.Count;
	}

    public Find(deviceID: string): Win32_DiskDriveEntry {
		return this._diskTable.Item(deviceID);
	}

    public Remove(deviceID: string): boolean {
        return this._diskTable.Remove(deviceID);
	}

    public ForEach(callbackfn: (value: Win32_DiskDriveEntry, index: number, array: Win32_DiskDriveEntry[]) => void, thisArg?: any): void {
		this._diskTable.Values().ForEach(callbackfn, thisArg);
	}

    public Some(callbackfn: (value: Win32_DiskDriveEntry, index: number, array: Win32_DiskDriveEntry[]) => boolean, thisArg?: any): boolean {
        return this._diskTable.Values().Some(callbackfn, thisArg);
	}

    public Every(callbackfn: (value: Win32_DiskDriveEntry, index: number, array: Win32_DiskDriveEntry[]) => boolean, thisArg?: any): boolean {
        return this._diskTable.Values().Every(callbackfn, thisArg);
	}

	public Write(obj: any, context: any): void {
		if (this._diskTable.Count > 0) {
			obj.w32_ddrv_info = {};
			obj = obj.w32_ddrv_info;

			obj.entries = [];
			ObjSerUtils.WriteObjSerCollection(obj.entries, this._diskTable.Values(), context);
		}
	}

	public Read(obj: any, context: any): void {
		if (!obj.w32_ddrv_info)
			throw new Error();
		obj = obj.w32_ddrv_info;

		this.Clear();

		if (obj.entries !== undefined) {
			obj.entries.forEach((value: any) => {
				let entry = new Win32_DiskDriveEntry();
				entry.Read(value, context);
				this.AddDiskDrive(entry);
			}, this);
		}
	}
}
